import { gql } from '@apollo/client/core';

export const deletePlcAlarmCode = gql`
  mutation deletePlcAlarmCode($id: String) {
    deletePlcAlarmCode(id: $id)
  }
`;
